import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import GlobalDataContext from "./../../../GlobalDataContext";

import "./../../scss/Basket/index.scss";
import StatisticResults from "./StatisticResults";
import PreviousRounds from "./PreviousRounds";
import cn from "clsx";

const Statistics = () => {
  const { state } = useContext(GlobalDataContext);
  const { t } = useTranslation();

  // const tabsTitles = ["statistics", "previousrounds"];
  const tabsTitles = ["previousrounds"];
  const [activeTabTitle, setActiveTabTitle] = useState(tabsTitles[0]);

  const changeActiveItem = event => {
    const tabId = event.currentTarget.getAttribute("data-tab-id");
    if (tabId === activeTabTitle) return;
    setActiveTabTitle(tabId);
  };
  return (
    <section className="statistic-aside">
      <div className="tabs">
        <nav
          className={cn("tabs-titles", {
            disable: false
          })}
        >
          {tabsTitles.map((item, i) => {
            return (
              <div
                key={i}
                data-tab-id={item}
                onClick={changeActiveItem}
                className={cn(
                  "tabs-titles-item",
                  {
                    active: activeTabTitle === item
                  },
                  {
                    disable: false
                  }
                )}
              >
                {item === "previousrounds" && t("prevRounds.previousRounds")}
                {item === "statistics" && t("statistics.statistics")}
              </div>
            );
          })}
        </nav>
        <div className="tabs-content" style={{ padding: "1rem 0.5rem 0 1rem" }}>
          {(state.slideAsideBlockId === "statistics" ||
            activeTabTitle === "statistics") && (
            <StatisticResults
              preNumbersUOText={state.lifecycleData.PreNumbersUOText}
              firstNumberUOText={state.lifecycleData.FirstNumberUOText}
              statisticData={state.statistics}
            />
          )}
          {(state.slideAsideBlockId === "betHistory" ||
            activeTabTitle === "previousrounds") && (
            <PreviousRounds
              roundsHistory={state.statistics.LastRounds ? state.statistics.LastRounds : []}
              preNumbersUOText={state.lifecycleData.PreNumbersUOText}
              firstNumberUOText={state.lifecycleData.FirstNumberUOText}
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default Statistics;
